import { render, staticRenderFns } from "./SideNavMini.vue?vue&type=template&id=d4afa16a&scoped=true"
import script from "./SideNavMini.vue?vue&type=script&lang=js"
export * from "./SideNavMini.vue?vue&type=script&lang=js"
import style0 from "./SideNavMini.vue?vue&type=style&index=0&id=d4afa16a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4afa16a",
  null
  
)

export default component.exports